import {
  defaultResource,
  resourceFromAttributes,
} from "@opentelemetry/resources";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
import { env } from "./utils/globalUtilities";

// Define resource and service attributes
const resource = defaultResource().merge(
  resourceFromAttributes({
    "service.name": `learning-frontend-${env()}`,
    "service.version": "0.1.0",
  })
);

// Set up the OTLP trace exporter
const exporter:any = new OTLPTraceExporter({
  url: "https://signoz.taxmann.dev/v1/traces",
});

// Set up the span processor
const processor:any = new BatchSpanProcessor(exporter);

// Create and configure the WebTracerProvidert
const provider = new WebTracerProvider({
  resource: resource,
  spanProcessors: [processor], // Add the span processor here
});

// Register the tracer provider with the context manager
provider.register({
  contextManager: new ZoneContextManager(),
});

// Set up automatic instrumentation for web APIs
registerInstrumentations({
  instrumentations: [
    getWebAutoInstrumentations({
      "@opentelemetry/instrumentation-xml-http-request": {
        propagateTraceHeaderCorsUrls: [
          /.+/g, // Regex to match your backend URLs
        ],
      },
      "@opentelemetry/instrumentation-fetch": {
        propagateTraceHeaderCorsUrls: [
          /.+/g, // Regex to match your backend URLs
        ],
      },
    }),
  ],
});
